const genExportChannelId = payload => {
    const {
        assetType,
        pptxMode = "static",
        presentationId,
        presentationLinkId,
        forPrinting,
        slideIds
    } = payload;

    const printing = forPrinting ? "printing" : "no-printing";
    const linkId = presentationLinkId || "no-link-id";
    const slideIdsKey = slideIds?.length ? slideIds.slice().sort().join(",") : "all-slides";

    return `private-export-${assetType}-${pptxMode}@${presentationId}@${linkId}@${printing}@${slideIdsKey}`;
};

module.exports = genExportChannelId;
